// Reference projects. To add a new project, append an object here —
// it automatically appears as a card in the references section.
// Display order = order in this list (largest to smallest area).
// Images are temporary placeholders until final project photos are provided.

export const projects = [
  {
    slug: "neubau-mfh-18-wohneinheiten",
    image:
      "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?q=80&w=1600&auto=format&fit=crop",
    title: {
      de: "Neubau eines Mehrfamilienhauses mit 18 Wohneinheiten",
      en: "New construction of a multi-family residential building with 18 units",
    },
    type: { de: "Mehrfamilienhaus / Wohngebäude", en: "Multi-family house / Residential building" },
    area: "ca. 4.000 m²",
    scope: { de: "Elektroplanung", en: "Electrical planning" },
    responsible: "ArStudio Elektro",
    excerpt: {
      de: "Vollständige elektrotechnische Planungsunterlagen für den Neubau eines Mehrfamilienhauses mit 18 Wohneinheiten — inklusive Beleuchtungs-, Steckdosen-, Stromkreis- und Verteilungsplanung.",
      en: "Complete electrical engineering planning documents for the new construction of a multi-family house with 18 units — including lighting, socket, circuit and distribution planning.",
    },
    description: {
      de: "Die Referenz umfasst die vollständigen elektrotechnischen Planungsunterlagen für den Neubau eines Mehrfamilienhauses mit 18 Wohneinheiten. Die Planung beinhaltet die Ausarbeitung der Elektroinstallationen für die einzelnen Wohneinheiten sowie die Allgemeinbereiche des Gebäudes, einschließlich Beleuchtungs-, Steckdosen-, Stromkreis- und Verteilungsplanung. Ergänzend wurden die erforderlichen technischen Schemata, Legenden und elektrotechnischen Berechnungen einschließlich der Kabel- und Leitungsdimensionierung erstellt.",
      en: "The reference comprises the complete electrical engineering planning documents for the new construction of a multi-family house with 18 units. The planning includes the elaboration of the electrical installations for the individual residential units as well as the common areas of the building, including lighting, socket, circuit and distribution planning. In addition, the required technical schematics, legends and electrical calculations including cable and wire sizing were created.",
    },
    detailsUrl:
      "https://drive.google.com/file/d/1HXx0egn3HtTtoZq6XoDH1waQMP2PnfHw/view?usp=sharing",
  },
  {
    slug: "kindergarten-4-gruppen",
    image: "/images/projects/kindergarten.png",
    title: {
      de: "Kindergarten mit 4 Gruppen – Elektroplanung",
      en: "Kindergarten with 4 groups – Electrical planning",
    },
    type: { de: "Bildungsgebäude / Kindergarten", en: "Educational building / Kindergarten" },
    area: "ca. 860 m²",
    scope: { de: "Elektroplanung", en: "Electrical planning" },
    responsible: "ArStudio Elektro",
    excerpt: {
      de: "Vollständige elektrotechnische Planungsunterlagen für einen Kindergarten mit vier Gruppen — von der Elektroinstallation bis zu Schemata und Berechnungen.",
      en: "Complete electrical engineering planning documents for a kindergarten with four groups — from electrical installation to schematics and calculations.",
    },
    description: {
      de: "Die Referenz umfasst die vollständigen elektrotechnischen Planungsunterlagen für einen Kindergarten mit vier Gruppen. Die Planung beinhaltet die Ausarbeitung der Elektroinstallationen, Beleuchtungs- und Steckdosenplanung, Stromkreis- und Verteilungsplanung sowie die erforderlichen technischen Schemata und elektrotechnischen Berechnungen.",
      en: "The reference comprises the complete electrical engineering planning documents for a kindergarten with four groups. The planning includes the elaboration of the electrical installations, lighting and socket planning, circuit and distribution planning, as well as the required technical schematics and electrical calculations.",
    },
    detailsUrl:
      "https://drive.google.com/file/d/1o3bMoVmqIsHOSyDUwsF8TV11rLdswzkZ/view?usp=sharing",
  },
  {
    slug: "mfh-gastronomie-umbau-erweiterung",
    image: "/images/projects/mfh-gastronomie.png",
    title: {
      de: "MFH mit Gastronomie – Umbau und Erweiterung eines Wohnhauses",
      en: "Multi-family house with gastronomy — conversion and extension of a residential building",
    },
    type: { de: "Gastronomie und Wohngebäude", en: "Gastronomy and residential building" },
    area: "ca. 750 m²",
    scope: { de: "Elektroplanung", en: "Electrical planning" },
    responsible: "ArStudio Elektro",
    excerpt: {
      de: "Planungsunterlagen, technische Schemata und elektrotechnische Berechnungen für den Umbau und die Erweiterung eines Wohnhauses mit Gastronomie.",
      en: "Planning documents, technical schematics and electrical calculations for the conversion and extension of a residential building with gastronomy.",
    },
    description: {
      de: "Die Referenz umfasst die erstellten Planungsunterlagen, technischen Schemata sowie die dazugehörigen elektrotechnischen Berechnungen für die Umsetzung des Projekts.",
      en: "The reference comprises the created planning documents, technical schematics and the associated electrical calculations for the implementation of the project.",
    },
    detailsUrl:
      "https://drive.google.com/file/d/1Jfk8NE1Xzfne2bIj4gEZSPUZos7Lrm49/view?usp=sharing",
  },
  {
    slug: "einfamilienhaus",
    image: "/images/projects/einfamilienhaus.png",
    title: {
      de: "Einfamilienhaus – Elektroplanung",
      en: "Single-family house – Electrical planning",
    },
    type: { de: "Einfamilienhaus", en: "Single-family house" },
    area: "ca. 300 m²",
    scope: { de: "Elektroplanung", en: "Electrical planning" },
    responsible: "ArStudio Elektro",
    excerpt: {
      de: "Vollständige elektrotechnische Planungsunterlagen für ein Einfamilienhaus — Beleuchtungs-, Steckdosen-, Stromkreis- und Verteilungspläne inklusive Berechnungen.",
      en: "Complete electrical engineering planning documents for a single-family house — lighting, socket, circuit and distribution plans including calculations.",
    },
    description: {
      de: "Die Referenz umfasst die vollständigen elektrotechnischen Planungsunterlagen für ein Einfamilienhaus mit einer Gesamtfläche von ca. 300 m². Neben der Planung der Elektroinstallation wurden detaillierte Beleuchtungs-, Steckdosen-, Stromkreis- und Verteilungspläne sowie die erforderlichen technischen Details, Schemata und elektrotechnischen Berechnungen erstellt.",
      en: "The reference comprises the complete electrical engineering planning documents for a single-family house with a total area of approx. 300 m². In addition to planning the electrical installation, detailed lighting, socket, circuit and distribution plans were created, as well as the required technical details, schematics and electrical calculations.",
    },
    detailsUrl:
      "https://drive.google.com/file/d/1O7SqPYzSk6tuIgTaF7bMSKurUBRODtkt/view?usp=sharing",
  },
];

export function getProject(slug) {
  return projects.find((p) => p.slug === slug);
}
